import React, { useCallback } from 'react';
import { useOutsideAlerter } from 'site-modules/shared/hooks/use-outside-alerter';
import { AbandonScreen } from 'site-modules/financing/components/abandon-screen/abandon-screen';

export function WithRejectionScreen({ children, isAbandonFlow, wrapperRef }) {
  const [isAbandonShow, url, setIsAbandonShow] = useOutsideAlerter(wrapperRef, { isAbandonFlow });

  const handleStayBtnClick = useCallback(() => setIsAbandonShow(false), [setIsAbandonShow]);

  return (
    <>
      {isAbandonShow && <AbandonScreen onStayClick={handleStayBtnClick} url={url} />}
      {!isAbandonShow && children}
    </>
  );
}
